import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../lib/redux/hooks'
import { MadfarmStaticSelect } from '../../../../ui/molecules/select/newSelect/static'
import TextArea from '../../../../ui/molecules/textArea'
import { formatterDate, IVModeOptions, IVTypeOptions, MultipleMonthOptions, normativa, optionsFormatter, OptionType, SingleMonthOptions } from '../../../../utils'
import { GetAllPac, resetGetAllPACsStatus, resetPACDetailCreationRequest, setPACDetailCreationAnnualControlPlaneId, setPACDetailCreationCustomerId, setPACDetailCreationMode, setPACDetailCreationPeriodicity, setPACDetailCreationSampling, setPACDetailCreationSpecifications, setPACDetailCreationVisitingType, setPACDetailsCreationNote } from '../slice'
import '../styles.scss'

export function AddPACForms() {
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const pacState = useAppSelector(state => state.pac)
    const [pacOptions, setPacOptions] = useState<OptionType[]>([])

    useEffect(() => {
        dispatch(GetAllPac(pacState.getAllPACsFilters))
        dispatch(resetPACDetailCreationRequest())
        dispatch(setPACDetailCreationCustomerId(sessionState.selected.customerId))
    }, [])

    useEffect(() => {
        if (pacState.getAllPACsStatus === 'successfully' &&
            pacState.getAllPACsResponse !== undefined
        ) {
            dispatch(resetGetAllPACsStatus())
            const data = pacState.getAllPACsResponse.data.filter(pac => pac.norm === sessionState.selected.customerNorm).map(pac => {
                return {
                    value: pac.id,
                    label: `Anno rif. ${pac.year} - ${optionsFormatter(pac.norm!, normativa)} - Valido dal ${formatterDate(pac.startingDate)} al ${formatterDate(pac.endingDate)}`
                } as OptionType
            })
            setPacOptions(data)
        }
    }, [pacState.getAllPACsStatus])

    return (
        <div className="flex flex-col gap-6 p-6">
            <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                <div className="bg-brandPrimary-600 px-6 py-4">
                    <span className="text-white font-semibold text-lg">PAC / Scegli riferimento PAC</span>
                </div>
                <div className="p-6">
                    <MadfarmStaticSelect
                        noOptionsMessage=''
                        error={pacState.PACDetailErrors.annualControlPlaneId}
                        errorLabel='Riferimento mancante'
                        placeholder={'Seleziona riferimento...'}
                        options={pacOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setPACDetailCreationAnnualControlPlaneId(newValue))
                        }}
                        value={pacState.PACDetailCreationRequest.annualControlPlaneId}
                    />
                </div>
            </div>
            <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                <div className="bg-brandPrimary-600 px-6 py-4">
                    <span className="text-white font-semibold text-lg">PAC / Dettagli</span>
                </div>
                <div className='flex flex-col gap-6 p-6'>
                    <div className='grid grid-cols-2 gap-6'>
                        <MadfarmStaticSelect
                            label="Periodo"
                            noOptionsMessage=''
                            error={pacState.PACDetailErrors.periodicity}
                            errorLabel='Periodicità mancante'
                            placeholder={'Seleziona periodo...'}
                            options={
                                sessionState.selected.customerNorm === 'NORMA_BIO'
                                    ? SingleMonthOptions
                                    : MultipleMonthOptions
                            }
                            value={pacState.PACDetailCreationRequest.periodicity?.join('-') || null}
                            onChange={(val) => {
                                const option = val as unknown as { value: string, label: string } | null;

                                const newValue = option?.value || null;

                                if (newValue) {
                                    dispatch(setPACDetailCreationPeriodicity(
                                        newValue.split('-').map((v: string) => Number(v))
                                    ));
                                } else {
                                    dispatch(setPACDetailCreationPeriodicity([]));
                                }
                            }}
                        />
                        <MadfarmStaticSelect
                            label="Modalità"
                            noOptionsMessage=''
                            error={pacState.PACDetailErrors.mode}
                            errorLabel='Modalità mancante'
                            placeholder={'Seleziona modalità...'}
                            options={IVModeOptions}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setPACDetailCreationMode(newValue))
                            }}
                        />
                    </div>
                    <div className='grid grid-cols-2 gap-6'>
                        <MadfarmStaticSelect
                            label="Tipo Visita"
                            error={pacState.PACDetailErrors.visitType}
                            errorLabel='Tipologia mancante'
                            placeholder={'Seleziona tipo...'}
                            options={IVTypeOptions}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setPACDetailCreationVisitingType(newValue))
                            }}
                            noOptionsMessage={''}
                        />
                        <MadfarmStaticSelect
                            label="Prelievo"
                            noOptionsMessage=''
                            error={pacState.PACDetailErrors.sampling}
                            errorLabel='Prelievo mancante'
                            placeholder={'Seleziona prelievo...'}
                            options={[{ value: 'Sì', label: 'Sì' }, { value: 'No', label: 'No' }]}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setPACDetailCreationSampling(newValue === 'Sì'))
                            }}
                        />
                    </div>
                    <TextArea
                        label="Specifiche"
                        onChangeText={(value) => dispatch(setPACDetailCreationSpecifications(value))}
                    />
                    <TextArea
                        label="Note"
                        onChangeText={(value) => dispatch(setPACDetailsCreationNote(value))}
                    />
                </div>
            </div>
        </div>
    )
}